/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HistoryAction = {
  type: 'Enum',
} as const;
